import React from 'react';
import { Link } from 'react-router-dom';
import { useMutation } from '@apollo/react-hooks';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircle';
import IconButton from '@material-ui/core/IconButton';
import { makeStyles, fade } from '@material-ui/core/styles';
import { Droppable } from 'react-beautiful-dnd';
import { UPDATE_SCHOOL } from 'graphql/student_college';
import SchoolCard from './SchoolCard';
import { useSelector } from 'react-redux';
import PRODUCTS from 'constant/product-types';

const PRODUCTS_LOOKUP = PRODUCTS.reduce((memo, i) => {
  memo[i.value] = i.label;
  return memo;
}, {});

const useStyles = makeStyles((theme) => ({
  root: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    height: 'calc(100vh - 150px)',
    minWidth: 250,
    backgroundColor: '#F1F1F1',
    borderRadius: 6,
  },
  header: {
    padding: theme.spacing(1),
  },
  list: {
    padding: theme.spacing(1),
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    overflowY: 'auto',
    overflowX: 'hidden',
  },
  cardContent: {
    padding: 0,
  },
  title: {
    flex: 1,
    marginLeft: theme.spacing(1),
    color: theme.palette.text.secondary,
    fontSize: 12,
    textTransform: 'uppercase',
    fontWeight: 700,
    letterSpacing: 1,
  },
  icon: {
    color: theme.palette.text.secondary,
  },
  row: {
    borderBottom: 'none',
  },
  datepicker: {
    '& .MuiOutlinedInput-input': {
      padding: 8,
      width: 130,
    },
  },
  item: {
    fontSize: 'inherit',
  },
}));

const SchoolList = ({
  schools,
  type,
  index,
  name,
  color,
  showScores,
  showDeadlines,
  toggleCard,
  setType,
  student
}) => {
  const classes = useStyles();
  const [updateSchool] = useMutation(UPDATE_SCHOOL);
  const user = useSelector((s) => s.user.user);
  const canEdit = user.type !== 'parent';
  const schoolCount = schools?.length || null;

  const onAdmissionTypeChange = (val, school) => {
    updateSchool({
      variables: {
        id: school.id,
        input: {
          admission_type: val,
        },
      },
    });
  };

  const onStatusChange = (val, school) => {
    window.analytics.track(`Application status changed`, {
      ...school,
      status: val,
      user,
      product: PRODUCTS_LOOKUP[student.product_type],
    });
    updateSchool({
      variables: {
        id: school.id,
        input: {
          status: val,
        },
      },
    });
  };

  const handleAdd = (type) => {
    setType(type)
    toggleCard(true)
  }

  return (
    <div className={classes.root}>
      <Box display="flex" alignItems="center" className={classes.header}>
        <Typography className={classes.title}>
          {name}
          {schoolCount && <span>{`(${schoolCount})`}</span>}
        </Typography>
        {canEdit && (
         
            <IconButton size="small" onClick={() => handleAdd(type)}>
              <AddCircleOutlineIcon className={classes.icon} fontSize="small" />
            </IconButton>
        
        )}
      </Box>
      <Droppable droppableId={type}>
        {(provided) => (
          <Box
            className={classes.list}
            ref={provided.innerRef}
            {...provided.droppableProps}
          >
            {schools.map((i, idx) => (
              <SchoolCard
                showScores={showScores}
                showDeadlines={showDeadlines}
                school={i}
                key={i.id}
                index={idx}
                onStatusChange={onStatusChange}
                onAdmissionTypeChange={onAdmissionTypeChange}
                user={user}
                color={color}
              />
            ))}
            {provided.placeholder}
          </Box>
        )}
      </Droppable>
    </div>
  );
};

export default SchoolList;
